import type { OrganizationPopoverContentProps } from "./organization-popover-content.type";

import { useTranslation } from "react-i18next";

import { FlexContainerText } from "@/modules/flex-container";
import { InterventionTemplateLabel } from "@/modules/intervention-template/intervention-template-label";
import { OrganizationLogo } from "@/modules/organization/organization-logo";

const FALLBACK_VALUE = "—";

export const OrganizationPopoverContent = ({
  organization,
}: OrganizationPopoverContentProps) => {
  const { t } = useTranslation();

  return (
    <div className="organization-popover-content">
      <FlexContainerText
        value={organization.description}
        label={t("organization:form.description.label")}
        fallback={FALLBACK_VALUE}
      />
      <FlexContainerText
        value={organization.address}
        label={t("organization:form.address.label")}
        fallback={FALLBACK_VALUE}
      />
      {organization.logo_document && (
        <FlexContainerText
          value={<OrganizationLogo organization={organization} />}
          label={t("organization:form.image.label")}
        />
      )}
      <InterventionTemplateLabel
        template={organization.default_template}
        fallback={FALLBACK_VALUE}
      />
      <FlexContainerText value={organization.id} label={t("global:id")} />
    </div>
  );
};
